import { render, staticRenderFns } from "./user-dashboard.vue?vue&type=template&id=0e06fe9a"
import script from "./user-dashboard.vue?vue&type=script&lang=js"
export * from "./user-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports